import { Cancel, Inventory } from '@mui/icons-material';
import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, Toolbar, Typography } from '@mui/material';
import UploadArquivo from './UploadArquivo';
import { inject, observer } from 'mobx-react';
import { action, makeObservable, observable } from 'mobx';
import ReactComponent from '@/components/ReactComponent';
import Tabs from './Tabs';
import DocumentoRepresentante from './DocumentoRepresentante';

class GerenciarSustentacaoOralDialog extends ReactComponent {
    open = false;
    documentosAtivos = [];
    documentosExcluidos = [];

    constructor(props) {
        super(props);

        makeObservable(this, {
            open: observable,
            documentosAtivos: observable,
            documentosExcluidos: observable,
            handleOpen: action,
            handleClose: action,
            getDocumentos: action,
            handleUpload: action
        });

        this.buscarDocumentos();
    }

    buscarDocumentos = () => {
        this.getDocumentos();
    };

    handleOpen = () => {
        this.open = true;
    };

    handleClose = () => {
        this.open = false;
    };

    getDocumentos = async () => {
        const documentosResponse = await this.advogadoSustentacaoOralService.listarDocumentos(
            this.observableProps.inscricaoId
        );
        this.documentosAtivos = documentosResponse.data.filter((documento) => documento.excluido === false);
        this.documentosExcluidos = documentosResponse.data.filter((documento) => documento.excluido === true);
    };

    handleUpload = async (file, handleProgresso) => {
        await this.advogadoSustentacaoOralService.uploadDocumentoParaInscricao(
            this.observableProps.sessaoId,
            this.observableProps.numeroProcesso,
            this.observableProps.representanteId,
            this.observableProps.codigoParte,
            file,
            handleProgresso
        );
        this.getDocumentos();
    };

    render() {
        return (
            <>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <Button
                        sx={{ whiteSpace: 'nowrap', minWidth: 'auto', mr: 1, ml: 2, width: '200px' }}
                        variant="contained"
                        onClick={this.handleOpen}
                        aria-label="Gerenciar arquivos"
                        endIcon={<Inventory />}
                    >
                        Gerenciar arquivos
                    </Button>
                </Box>
                <Dialog
                    open={this.open}
                    onClose={this.handleClose}
                    sx={{ width: '80wh' }}
                    maxWidth="xl"
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography>
                                Sustentações orais eletrônicas do processo {this.observableProps.numeroProcesso}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <DialogContent sx={{ height: '80vh', minWidth: '70vw' }}>
                        <Tabs
                            tabs={[
                                {
                                    id: 1,
                                    titulo: 'Enviar novo arquivo',
                                    conteudo: <UploadArquivo onUploadDocumento={this.handleUpload} />
                                },
                                {
                                    id: 2,
                                    titulo: 'Documentos enviados',
                                    conteudo:
                                        this.documentosAtivos.length === 0 ? (
                                            <Typography>Não há documentos enviados disponíveis.</Typography>
                                        ) : (
                                            this.documentosAtivos?.map(
                                                ({ id, nome, dataDocumento, excluido, documentoValidacao }) => (
                                                    <DocumentoRepresentante
                                                        key={id}
                                                        id={id}
                                                        nome={nome}
                                                        dataDocumento={dataDocumento}
                                                        excluido={excluido}
                                                        documentoValidacao={documentoValidacao}
                                                        onRemoveDocumento={this.getDocumentos}
                                                        exibirStatus={true}
                                                    />
                                                )
                                            )
                                        )
                                },
                                {
                                    id: 3,
                                    titulo: 'Documentos excluídos',
                                    conteudo:
                                        this.documentosExcluidos.length === 0 ? (
                                            <Typography>Não há documentos excluídos disponíveis.</Typography>
                                        ) : (
                                            this.documentosExcluidos?.map(({ id, nome, dataDocumento, excluido }) => (
                                                <DocumentoRepresentante
                                                    key={id}
                                                    id={id}
                                                    nome={nome}
                                                    dataDocumento={dataDocumento}
                                                    excluido={excluido}
                                                    onRemoveDocumento={this.getDocumentos}
                                                    exibirStatus={false}
                                                />
                                            ))
                                        )
                                }
                            ]}
                        />
                    </DialogContent>
                    <DialogActions sx={{ my: 1, mx: 2 }}>
                        <Button
                            color="secondary"
                            onClick={this.handleClose}
                            variant="outlined"
                            endIcon={<Cancel />}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default inject('stores')(observer(GerenciarSustentacaoOralDialog));
